// Opens Razorpay's hosted Checkout widget (script loaded globally in
// public/index.html, exposing window.Razorpay). Shared between the /renew
// page and the in-app "renew now" banner so the invocation only lives once.
export function openRazorpayCheckout({ order, config, prefillEmail, onSuccess, onDismiss }) {
  if (!window.Razorpay) {
    throw new Error('Razorpay checkout script failed to load');
  }

  const rzp = new window.Razorpay({
    key: config.keyId,
    amount: order.amount,
    currency: order.currency,
    order_id: order.orderId,
    name: 'ProfitLedgex',
    description: 'Subscription Renewal',
    prefill: prefillEmail ? { email: prefillEmail } : undefined,
    handler: (response) => onSuccess(response),
    modal: {
      ondismiss: () => {
        if (onDismiss) onDismiss();
      },
    },
  });

  rzp.open();
}
